import { Text } from "@solomon-apps/shared/src/components/ui/text";
import { IndicationUnit } from "@solomon-labs/design/components/ui";
import type { ReactElement } from "react";

/**
 * Onboarding "under review" state — shown after a lite application is submitted
 * and is pending issuer review (status `in_review`, before approval). Mirrors
 * the `CelebrationCard` page layout (top-aligned `mt-25`, centered, H1 + body)
 * but swaps the success check for the connecting indicator and drops the CTA —
 * the client just waits for the email update.
 */
export function PendingReviewCard(): ReactElement {
    return (
        <div className="mt-25">
            <section className="flex justify-center">
                <div className="px-12 py-12 w-full text-center">
                    {/* Connecting indicator attached to the heading's top-left.
                        `pairWith` DOES support the `connect` variant — the
                        component wraps the dot in its own aligned span
                        (`wrapAligned`) and takes both size and top-pad from
                        PAIR_DEFAULTS.h1. This call site used to reproduce those
                        values by hand, which pinned the dot at size 8 on every
                        breakpoint where the preset wants 7 on mobile. The title
                        must still NOT override its leading — the alignment is
                        tuned to the h1 variant's native leading. */}
                    <div className="flex items-start justify-center gap-2">
                        <IndicationUnit
                            variant="connect"
                            state="connecting"
                            pairWith="h1"
                        />
                        <Text
                            variant="h1"
                            render={<h1 />}
                            className="text-foreground-base"
                        >
                            Your submission is being reviewed
                        </Text>
                    </div>
                    <div className="pt-12">
                        <Text
                            variant="body"
                            className="block text-foreground-base"
                        >
                            You will be alerted via email of any updates.
                        </Text>
                    </div>
                </div>
            </section>
        </div>
    );
}
